import {
  Card,
  message,
  Spin,
  Tag,
  Button,
  Col,
  Row,
  DatePicker,
  Select,
  Space,
  Empty,
  Tooltip,
  Typography,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";

import ReactECharts from "echarts-for-react";
import {
  BarChartOutlined,
  CalendarOutlined,
  InboxOutlined,
  ClockCircleOutlined,
  FileProtectOutlined,
  CheckOutlined,
  LockOutlined,
  BankOutlined,
  ReloadOutlined,
  UserOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";

//use redux
import axios from "axios";
import DateCustom from "../../../hook/DateCustom";
import dayjs from "dayjs";
import DataCheck from "./modal/DataCheck";
import {
  ASSET_FLAG_GROUPS,
  enrichCase,
  exportCasesExcel,
  getSeizeGroupKey,
  getSeizeStatusText,
  loadLoanByContno,
  SEIZE_GROUPS,
  toArgb,
} from "./EnforceCaseUtils";
import { baseUrl, HEADERS_EXPORT } from "../../API/apiUrls";
import LoadLawyers from "../chargeIndict/hook/LoadLawyers";

const SEIZE_ICONS = {
  notSeize: <ClockCircleOutlined />,
  setupSeize: <FileProtectOutlined />,
  seizeSuccess: <CheckOutlined />,
  sequestrated: <LockOutlined />,
  mortgaged: <BankOutlined />,
};

const NO_LAWYER = "ไม่ระบุผู้รับผิดชอบ";
const ALL_LABEL = "ทั้งหมด";

// กลุ่มข้อมูลของผู้รับผิดชอบ 1 คน (หรือรวมทุกคน)
const createGroup = () => {
  const group = { all: [] };
  [...SEIZE_GROUPS, ...ASSET_FLAG_GROUPS].forEach((g) => (group[g.key] = []));
  return group;
};

const addToGroup = (group, item) => {
  group.all.push(item);
  group[getSeizeGroupKey(item.seize_status)].push(item);
  ASSET_FLAG_GROUPS.forEach((g) => {
    if (g.test(item)) group[g.key].push(item);
  });
};
const ALL_LAWYERS = "all";

const Main = () => {
  const [, convertDateThaiShort] = DateCustom();
  const [loading, setLoading] = useState(false);
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isModalCheckData, setIsModalCheckData] = useState(false);
  const [statusData, setStatusData] = useState();
  const [isActive, setIsActive] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [lawyersList, setLoadingLawyers] = LoadLawyers();
  // ทนาย (ROLE_ID 3) เห็นเฉพาะของตัวเอง
  const [selectedLawyer, setSelectedLawyer] = useState(
    ROLE_ID === "3" ? userId : ALL_LAWYERS,
  );
  const [dateRange, setDateRange] = useState([
    dayjs().startOf("year"),
    dayjs(),
  ]);
  const [lastLoadedAt, setLastLoadedAt] = useState(null);
  // ข้อมูลสืบทรัพย์/ยึดทรัพย์ (เฉพาะที่มี seize_status)
  const [arrayTable, setArrayTable] = useState([]);

  // รองรับ response ทั้งแบบ array ตรง ๆ และแบบห่อด้วย { data: [...] }
  const lawyerArr = useMemo(
    () =>
      Array.isArray(lawyersList)
        ? lawyersList
        : Array.isArray(lawyersList?.data)
          ? lawyersList.data
          : [],
    [lawyersList],
  );

  const isCompany3 = userCompany === "3";
  const companyIds = useMemo(() => (isCompany3 ? [3] : [1, 2]), [isCompany3]);

  const lawyersOption = useMemo(() => {
    // บริษัท 3 ใช้ ROLE_ID 4, บริษัทอื่นใช้ ROLE_ID 3 หรือ 4
    const roleIds = isCompany3 ? [4] : [3, 4];
    // แปลงเป็น Number ก่อนเทียบ เผื่อ API ส่งค่ามาเป็น string
    const options = lawyerArr
      .filter(
        (item) =>
          companyIds.includes(Number(item.COMPANY_ID)) &&
          roleIds.includes(Number(item.ROLE_ID)) &&
          Number(item.ACTIVE_STATUS) === 1,
      )
      .map((item) => ({ value: item.id, label: item.NNAME }));
    return [{ value: ALL_LAWYERS, label: "ทั้งหมด" }, ...options];
  }, [lawyerArr, isCompany3, companyIds]);

  // id ผู้รับผิดชอบที่อยู่ในตัวเลือก (ใช้กับ "ทั้งหมด")
  const allowedLawyerIds = useMemo(
    () =>
      new Set(
        lawyersOption
          .filter((opt) => opt.value !== ALL_LAWYERS)
          .map((opt) => Number(opt.value)),
      ),
    [lawyersOption],
  );

  // id -> ชื่อเล่นทนาย (ใช้ทุกคน ไม่กรอง role เพื่อให้แสดงชื่อได้ครบ)
  const lawyerNameById = useMemo(() => {
    const map = {};
    lawyerArr.forEach((item) => {
      map[Number(item.id)] = item.NNAME;
    });
    return map;
  }, [lawyerArr]);

  const datePresets = [
    { label: "เดือนนี้", value: [dayjs().startOf("month"), dayjs()] },
    {
      label: "เดือนที่แล้ว",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "3 เดือนล่าสุด",
      value: [dayjs().subtract(3, "month").startOf("month"), dayjs()],
    },
    { label: "ปีนี้", value: [dayjs().startOf("year"), dayjs()] },
  ];

  useEffect(() => {
    setLoadingLawyers(true);
  }, [setLoadingLawyers]);

  useEffect(() => {
    loadInvestigateData();
  }, []);

  const loadInvestigateData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        baseUrl + `/lawyer/api/investigate-properties`,
        {
          headers: HEADERS_EXPORT,
        },
      );

      const responseData = response.data;

      if (Array.isArray(responseData) && responseData.length > 0) {
        const newData = responseData.map((item, index) => ({
          ...item,
          key: index + 1,
        }));

        filterInvestigateData(newData);
      } else {
        setArrayTable([]);
        message.info("ไม่พบข้อมูล");
      }
      setLastLoadedAt(dayjs());
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message,
      );
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // เอาทุกรายการ (seize_status null = ยังไม่ยึด)
  const filterInvestigateData = (data) => {
    const filtered = data.map((item) => ({
      ...item,
      seize_status_text: getSeizeStatusText(item.seize_status),
    }));

    setArrayTable(filtered);
  };

  // กรองตามผู้รับผิดชอบ (investigator_user_id) + ช่วงวันที่ (seize_date ถ้าไม่มีใช้ investigation_date)
  // แล้วแปลง field ให้ตรงกับที่ DataCheck / excel ใช้
  const arrData = useMemo(() => {
    const [start, end] = dateRange || [];
    return arrayTable
      .filter((item) => {
        const hasLawyer =
          item.investigator_user_id !== null &&
          item.investigator_user_id !== undefined;
        const lawyerId = Number(item.investigator_user_id);
        // ทั้งหมด = ผู้รับผิดชอบที่อยู่ในตัวเลือก (กรองตาม userCompany แล้ว)
        // + รายการที่ยังไม่มีผู้รับผิดชอบ ของบริษัทเดียวกัน
        if (
          selectedLawyer === ALL_LAWYERS
            ? hasLawyer
              ? !allowedLawyerIds.has(lawyerId)
              : !companyIds.includes(Number(item.COMPANY_ID))
            : lawyerId !== selectedLawyer
        ) {
          return false;
        }
        if (!start || !end) return true;
        const date = item.seize_date || item.investigation_date;
        if (!date) return false;
        const d = dayjs(date);
        return (
          !d.isBefore(start.startOf("day")) && !d.isAfter(end.endOf("day"))
        );
      })
      .map((item) => ({
        ...item,
        LAWYER_NNAME:
          lawyerNameById[Number(item.investigator_user_id)] || NO_LAWYER,
        main_status_description: item.seize_status_text,
        CUSTOMER_TNAME: item.SNAM,
        CUSTOMER_FNAME: item.NAME1,
        CUSTOMER_LNAME: item.NAME2,
      }));
  }, [
    arrayTable,
    selectedLawyer,
    dateRange,
    lawyerNameById,
    allowedLawyerIds,
    companyIds,
  ]);

  // จัดกลุ่มตามผู้รับผิดชอบ -> ขั้นตอนการทำงาน
  const cancelData = useMemo(() => {
    const groupedByLawyer = {};
    arrData.forEach((item) => {
      const lawyerName = item.LAWYER_NNAME;
      if (!groupedByLawyer[lawyerName]) {
        groupedByLawyer[lawyerName] = createGroup();
      }
      addToGroup(groupedByLawyer[lawyerName], item);
    });
    return groupedByLawyer;
  }, [arrData]);

  // รวมทุกคนในกราฟ (ใช้ตอนเลือก "ทั้งหมด")
  const allLawyersData = useMemo(() => {
    const group = createGroup();
    arrData.forEach((item) => addToGroup(group, item));
    return group;
  }, [arrData]);

  // เลือก "ทั้งหมด" -> แสดงรายละเอียดรวมทุกคน, เลือกคนเดียว -> แสดงคนนั้น
  useEffect(() => {
    if (selectedLawyer === ALL_LAWYERS) {
      setSelectedMonth(ALL_LABEL);
    } else if (!cancelData[selectedMonth]) {
      setSelectedMonth(Object.keys(cancelData)[0] || null);
    }
  }, [cancelData, selectedLawyer]);

  const selectedData =
    selectedMonth === ALL_LABEL
      ? allLawyersData
      : selectedMonth
        ? cancelData[selectedMonth]
        : null;

  const BarChart = () => {
    const lawyerNames = Object.keys(cancelData).filter(Boolean);

    const chartData = [
      ["ผู้รับผิดชอบ", ...SEIZE_GROUPS.map((s) => s.label)],
      ...lawyerNames.map((lawyerName) => {
        const data = cancelData[lawyerName] || {};
        return [
          lawyerName,
          ...SEIZE_GROUPS.map((s) => data[s.key]?.length || 0),
        ];
      }),
    ];

    const option = {
      legend: { top: 0 },
      grid: { top: 50, left: 40, right: 40, bottom: 30 },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {},
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      dataset: {
        source: chartData,
      },
      xAxis: { type: "category" },
      yAxis: { type: "value", minInterval: 1 },
      series: SEIZE_GROUPS.map((s) => ({
        type: "bar",
        name: s.label,
        barMaxWidth: 48,
        label: {
          show: true,
          position: "top",
          formatter: (p) =>
            p.value[p.encode.y[0]] ? p.value[p.encode.y[0]] : "",
        },
        itemStyle: {
          color: s.color,
          borderRadius: [8, 8, 0, 0],
        },
      })),
    };
    return (
      <ReactECharts
        option={option}
        style={{ height: 400, width: "100%" }}
        onEvents={{ click: onChartClick }}
      />
    );
  };

  const onChartClick = (params) => {
    if (cancelData[params.name]) setSelectedMonth(params.name);
  };

  const exportSubtitle = dateRange?.[0]
    ? `${selectedMonth || ""} | ช่วงวันที่ ${dateRange[0].format(
        "DD/MM/YYYY",
      )} - ${dateRange[1].format("DD/MM/YYYY")}`
    : selectedMonth || "";

  // export excel แยก sheet ตามขั้นตอนการทำงาน + sheet สรุป
  const exportAllExcel = async () => {
    if (!selectedData?.all?.length) {
      message.warning("ไม่มีข้อมูลสำหรับ export");
      return;
    }
    setExporting(true);
    try {
      const loanByContno = await loadLoanByContno(selectedData.all);
      await exportCasesExcel({
        sheets: [
          ...SEIZE_GROUPS,
          ...ASSET_FLAG_GROUPS.map((group) => ({ ...group, extra: true })),
        ].map((group) => ({
          label: group.label,
          color: toArgb(group.color),
          extra: group.extra,
          rows: (selectedData[group.key] || []).map((item) =>
            enrichCase(item, loanByContno),
          ),
        })),
        subtitle: exportSubtitle,
        formatDate: convertDateThaiShort,
        fileName: `รายงานยึดทรัพย์_${selectedMonth || ""}_${dayjs().format(
          "YYYYMMDD_HHmm",
        )}.xlsx`,
      });
    } catch (error) {
      console.error(error);
      message.error("Export Excel ไม่สำเร็จ");
    } finally {
      setExporting(false);
    }
  };

  const handleData = (status) => {
    setStatusData(status);
    setIsModalCheckData(true);
  };

  const tagStyle = {
    fontSize: "16px",
    padding: "10px 16px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: "bold",
    cursor: "pointer",
    transform: isActive ? "scale(0.96)" : "scale(1)",
    boxShadow: isActive ? "inset 0 2px 5px rgba(0,0,0,0.2)" : "none",
    transition: "transform 0.1s ease, box-shadow 0.1s ease",
  };

  const renderGroupTag = (group) => (
    <Tag
      key={group.key}
      color={group.color}
      style={{ ...tagStyle, color: "#fff" }}
      onClick={() => handleData(group.key)}
      className="clickable-tag"
      onMouseDown={() => setIsActive(true)}
      onMouseUp={() => setIsActive(false)}
      onMouseLeave={() => setIsActive(false)}
    >
      {SEIZE_ICONS[group.key]} {group.label}:{" "}
      {selectedData?.[group.key]?.length || 0} รายการ
      {selectedData?.all?.length > 0 && (
        <span
          style={{
            marginLeft: 4,
            fontSize: "11px",
            opacity: 0.9,
          }}
        >
          (
          {(
            (selectedData[group.key].length / selectedData.all.length) *
            100
          ).toFixed(1)}
          %)
        </span>
      )}
    </Tag>
  );

  if (ROLE_ID === "4") {
    return <Card>ไม่มีสิทธ์เข้าถึงข้อมูล</Card>;
  } else {
    return (
      <>
        <Card
          style={{
            marginBottom: 16,
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
          styles={{ body: { padding: 20 } }}
        >
          <Row
            justify="space-between"
            align="middle"
            gutter={[16, 8]}
            style={{ marginBottom: 16 }}
          >
            <Col>
              <Typography.Title level={4} style={{ margin: 0 }}>
                <BarChartOutlined
                  style={{ color: "#3357FF", marginRight: 8 }}
                />
                รายงานยึดทรัพย์
              </Typography.Title>
            </Col>
            <Col>
              {lastLoadedAt && (
                <Typography.Text type="secondary" style={{ fontSize: 13 }}>
                  <ClockCircleOutlined style={{ marginRight: 4 }} />
                  อัปเดตล่าสุด {lastLoadedAt.format("DD/MM/YYYY HH:mm:ss")}
                </Typography.Text>
              )}
            </Col>
          </Row>

          <div
            style={{
              background: "#f7f9fc",
              border: "1px solid #e8edf5",
              borderRadius: 10,
              padding: 16,
            }}
          >
            <Row gutter={[16, 16]} align="bottom">
              <Col xs={24} md={8}>
                <Typography.Text
                  strong
                  style={{ display: "block", marginBottom: 6 }}
                >
                  <UserOutlined style={{ marginRight: 6 }} />
                  ผู้รับผิดชอบ
                </Typography.Text>
                <Select
                  showSearch
                  allowClear={ROLE_ID !== "3"}
                  disabled={ROLE_ID === "3"}
                  placeholder="เลือกผู้รับผิดชอบ"
                  style={{ width: "100%" }}
                  optionFilterProp="label"
                  options={lawyersOption}
                  value={selectedLawyer}
                  onChange={(value) => setSelectedLawyer(value ?? ALL_LAWYERS)}
                />
              </Col>
              <Col xs={24} md={9}>
                <Typography.Text
                  strong
                  style={{ display: "block", marginBottom: 6 }}
                >
                  <CalendarOutlined style={{ marginRight: 6 }} />
                  ช่วงวันที่
                </Typography.Text>
                <DatePicker.RangePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  presets={datePresets}
                  allowClear={false}
                  value={dateRange}
                  onChange={(value) => setDateRange(value)}
                />
              </Col>
              <Col xs={24} md={7}>
                <Space wrap>
                  <Tooltip title="โหลดข้อมูลจากระบบอีกครั้ง">
                    <Button
                      icon={<ReloadOutlined spin={loading} />}
                      disabled={loading}
                      onClick={loadInvestigateData}
                    >
                      รีโหลด
                    </Button>
                  </Tooltip>
                </Space>
              </Col>
            </Row>
          </div>

          <Space wrap size={[8, 8]} style={{ marginTop: 16 }}>
            {selectedLawyer !== ALL_LAWYERS && (
              <Tag color="blue" style={{ fontSize: 14, padding: "4px 10px" }}>
                <UserOutlined style={{ marginRight: 4 }} />
                {lawyerNameById[selectedLawyer] || NO_LAWYER}
              </Tag>
            )}
            <Tag color="geekblue" style={{ fontSize: 14, padding: "4px 10px" }}>
              <FileProtectOutlined style={{ marginRight: 4 }} />
              {arrData.length} รายการ
            </Tag>
            {dateRange?.[0] && (
              <Tag style={{ fontSize: 14, padding: "4px 10px" }}>
                <CalendarOutlined style={{ marginRight: 4 }} />
                {dateRange[0].format("DD/MM/YYYY")} -{" "}
                {dateRange[1].format("DD/MM/YYYY")}
              </Tag>
            )}
          </Space>
        </Card>

        <Card
          style={{ borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
        >
          <Spin spinning={loading} size="large" tip=" Loading... ">
            {Object.keys(cancelData).length > 0 ? (
              BarChart()
            ) : (
              <Empty
                style={{ padding: "60px 0" }}
                description="ไม่พบข้อมูลตามผู้รับผิดชอบ / ช่วงวันที่ที่เลือก"
              />
            )}

            <>
              <Button
                type="primary"
                icon={<FileExcelOutlined />}
                loading={exporting}
                disabled={!selectedData?.all?.length}
                style={{ marginTop: 10, background: "#217346" }}
                onClick={exportAllExcel}
              >
                Export Excel (แยกตามขั้นตอน) {selectedMonth}
              </Button>

              <div
                style={{
                  marginTop: 24,
                  padding: "20px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "16px",
                  background: "#f9f9f9",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                }}
              >
                <h3
                  style={{
                    marginBottom: 20,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <BarChartOutlined
                    style={{ color: "#1890ff", fontSize: "20px" }}
                  />
                  รายละเอียดข้อมูล: <b>{selectedMonth}</b>
                  {selectedLawyer === ALL_LAWYERS &&
                    selectedMonth !== ALL_LABEL && (
                      <Button
                        size="small"
                        style={{ marginLeft: 8 }}
                        onClick={() => setSelectedMonth(ALL_LABEL)}
                      >
                        แสดงทั้งหมด
                      </Button>
                    )}
                </h3>

                {/* ส่วนที่ 1: สรุปข้อมูลทั้งหมด */}
                <div style={{ marginBottom: 16 }}>
                  <Tag
                    color="#3357FF"
                    style={{
                      ...tagStyle,
                      color: "#fff",
                      fontSize: "16px",
                      padding: "8px 16px",
                    }}
                    onClick={() => handleData("all")}
                    className="clickable-tag"
                    onMouseDown={() => setIsActive(true)}
                    onMouseUp={() => setIsActive(false)}
                    onMouseLeave={() => setIsActive(false)}
                  >
                    <InboxOutlined /> ทั้งหมด: {selectedData?.all?.length || 0}{" "}
                    รายการ
                  </Tag>
                </div>

                {/* ส่วนที่ 2: ขั้นตอนการทำงาน */}
                <div style={{ marginBottom: 12 }}>
                  <h4 style={{ marginBottom: 8, color: "#595959" }}>
                    📋 ขั้นตอนการทำงาน
                  </h4>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {SEIZE_GROUPS.map(renderGroupTag)}
                  </div>
                </div>

                {/* ส่วนที่ 3: สถานะทรัพย์ (นับซ้ำกับขั้นตอนการทำงานได้) */}
                <div style={{ marginBottom: 12 }}>
                  <h4 style={{ marginBottom: 8, color: "#595959" }}>
                    🏷️ สถานะทรัพย์
                  </h4>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {ASSET_FLAG_GROUPS.map(renderGroupTag)}
                  </div>
                </div>
              </div>
            </>
          </Spin>
        </Card>

        <DataCheck
          open={isModalCheckData}
          close={setIsModalCheckData}
          data={selectedData}
          status={statusData}
          lawyerName={selectedMonth}
          subtitle={exportSubtitle}
        />
      </>
    );
  }
};

const EnforceReport = MotionHoc(Main);
export default EnforceReport;
